import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQ = ({ language }) => {
  const content = {
    es: {
      title: "Preguntas frecuentes",
      subtitle: "Todo lo que necesitas saber antes de contactarme",
      faqs: [
        {
          question: "¿Cómo pido presupuesto?",
          answer:
            "Envíame fotos o un vídeo por WhatsApp + tu zona (barrio) + qué necesitas + si hay ascensor. Te respondo con precio y disponibilidad.",
        },
        {
          question: "¿Cuánto cuesta?",
          answer:
            "Depende del trabajo. Para tareas rápidas, desde 35€ (hasta 1 hora). Para trabajos grandes, doy precio cerrado después de ver fotos.",
        },
        {
          question: "¿Haces trabajos urgentes / el mismo día?",
          answer:
            "Sí, cuando estoy disponible. Escríbeme por WhatsApp y dime si es urgente.",
        },
        {
          question: "¿En qué zonas trabajas?",
          answer:
            "Valencia y alrededores (según distancia). Envíame tu ubicación y te confirmo.",
        },
        {
          question: "¿Qué métodos de pago aceptas?",
          answer:
            "Efectivo. Si lo prefieres, lo confirmamos antes de la visita.",
        },
        {
          question: "¿Traes herramientas?",
          answer:
            "Sí, llevo herramientas básicas para la mayoría de montajes y reparaciones. Si hace falta algo específico, te lo digo antes.",
        },
      ],
    },
    en: {
      title: "Frequently asked questions",
      subtitle: "Everything you need to know before contacting me",
      faqs: [
        {
          question: "How do I get a quote?",
          answer:
            "Send photos or a short video on WhatsApp + your area + what you need + whether there's an elevator. I'll reply with price and availability.",
        },
        {
          question: "How much does it cost?",
          answer:
            "It depends on the job. For quick jobs, from €35 (up to 1 hour). For bigger jobs, I give a fixed quote after photos.",
        },
        {
          question: "Do you do urgent / same-day jobs?",
          answer:
            "Yes, if I'm available. Message me on WhatsApp and tell me it's urgent.",
        },
        {
          question: "What areas do you cover?",
          answer:
            "Valencia and nearby areas (depending on distance). Send your location and I'll confirm.",
        },
        {
          question: "What payment methods do you accept?",
          answer:
            "Cash. If you prefer, we'll confirm before the visit.",
        },
        {
          question: "Do you bring tools?",
          answer:
            "Yes, I bring basic tools for most assembly and repairs. If something specific is needed, I'll tell you beforehand.",
        },
      ],
    },
  };

  const currentContent = content[language];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {currentContent.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {currentContent.subtitle}
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <Accordion type="single" collapsible className="w-full">
            {currentContent.faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-b border-gray-200 last:border-0"
              >
                <AccordionTrigger className="px-6 py-5 text-left hover:bg-gray-50 hover:no-underline">
                  <span className="text-lg font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-5 pt-2">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
